import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "15", x2: "9", y1: "10", y2: "10", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BookmarkMinus";
const BookmarkMinus = memo(themed(Icon));
export {
  BookmarkMinus
};
//# sourceMappingURL=bookmark-minus.js.map
